'use client'

import { useState } from 'react'
import { useStore } from '@/store'
import { DeluxeBooksRegistryFooter } from './DeluxeBooksRegistryFooter'
import { DeluxeBooksSuccess } from './DeluxeBooksSuccess'
import { DeluxeSignupFormCard } from './DeluxeSignupFormCard'
import { DeluxeSignupGuestForm } from './DeluxeSignupGuestForm'
import { DeluxeSignupLoggedInBlock } from './DeluxeSignupLoggedInBlock'

export function DeluxeBooksSignup() {
  const user = useStore(state => state.user)
  const [success, setSuccess] = useState(false)

  if (success) {
    return <DeluxeBooksSuccess />
  }

  return (
    <div className="max-w-3xl mx-auto">
      <DeluxeSignupFormCard>
        {user ? (
          <DeluxeSignupLoggedInBlock onSuccess={() => setSuccess(true)} />
        ) : (
          <DeluxeSignupGuestForm onSuccess={() => setSuccess(true)} />
        )}
      </DeluxeSignupFormCard>
      <DeluxeBooksRegistryFooter />
    </div>
  )
}
